import React, { useCallback } from 'react';
import styled from 'styled-components';
import { invokeLater } from '../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { CommandRegistry } from '../../concepts/commands/CommandRegistry';
import { Fill } from '../../ui/Fill';
import { useResolve } from '../Container';
import { GoItem, GoPalette, GoResult } from './../../ui';
import { EditorSession, useEditorSessionObserver } from './EditorSession';
import { StatePropertyRef } from './ExtendableStore';
import { MyRoleInfo } from './MyRoleInfo';
import { IsElevated } from './workflow/IsElevated';

export const IsEditorPaletteOpen = StatePropertyRef<boolean>('isEditorPaletteOpen');

const Frame = styled(Fill)`
    z-index: 1;
    pointer-events: none;
    & > * {
        pointer-events: all;
    }
`;

export const EditorPalette = React.memo(() => {

    const commands = useResolve(CommandRegistry);
    const dispatch = useResolve(CommandDispatcher);
    const session = useResolve(EditorSession);

    const open = useEditorSessionObserver(IsEditorPaletteOpen);
    const { canParticipate } = useEditorSessionObserver(MyRoleInfo);
    const elevated = useEditorSessionObserver(IsElevated);

    const provider = useCallback((input: string) => commands.suggest(input, true) as GoItem[], [commands]);

    const onResult = useCallback((result: GoResult) => {
        if (result.success) {
            dispatch(result.item as any, result.params);
        }
        session.update(IsEditorPaletteOpen, false);
        // 1337 Hack St. Hackford, Hack City, HA3 7ER
        invokeLater(() => {
            document.getElementById('tool-layer').focus();
        });
    }, []);

    return <Frame>
        {open && canParticipate && elevated && <GoPalette provider={provider} callback={onResult} />}
    </Frame>;
});
